// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { Token } from '@lumino/coreutils';
/**
 * The main menu token.
 */
export const IMainMenu = new Token('@jupyterlab/mainmenu:IMainMenu', `A service for the main menu bar for the application.
  Use this if you want to add your own menu items or provide implementations for standardized menu items for specific activities.`);
//# sourceMappingURL=tokens.js.map